import React from "react";

import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import FemalePrisonPopulationTrend from "./chart/FemalePrisonPopulationTrend";
import FemalePrisonPopulationTrendBal from "./chart/FemalePrisonPopulationTrendBal";
import FemalePrisonPopulationTrendKpk from "./chart/FemalePrisonPopulationTrendKpk";
import FemalePrisonPopulationTrendPunjab from "./chart/FemalePrisonPopulationTrendPunjab";
import FemalePrisonPopulationTrendSindh from "./chart/FemalePrisonPopulationTrendSindh";

function WomenPrisonStatistics() {
  return (
    <div className="py-5">
      <h2 className="text-h-black">Women's Prison Statistics</h2>
      <div className="row row-cols-1 row-cols-md-4 py-5">
        <div className="col">
          <p className="punjab-static-h">
            <b>PUNJAB</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={920} redraw={true} separator=",">
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                *
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                by end of Year 2021
              </p>
            </div>
          </div>
          <FemalePrisonPopulationTrendPunjab />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>SINDH</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={240} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                by end of Year 2021
              </p>
            </div>
          </div>
          <FemalePrisonPopulationTrendSindh />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>KP</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={196} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                by end of Year 2021
              </p>
            </div>
          </div>
          <FemalePrisonPopulationTrendKpk />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Balochistan</b>
          </p>
          <div className="d-flex align-items-end">
            <div className="col">
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={35} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                *
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                currently, Aug 2022
              </p>
            </div>
          </div>
          <FemalePrisonPopulationTrendBal />
        </div>
      </div>

      <div className="row row-cols-1 row-cols-md-3">
        <div className="col">
          <p className="punjab-static-h">
            <b>INCREASING POPULATION</b>
          </p>

          <FemalePrisonPopulationTrend />
        </div>
        <div className="col">
          <div>
            <div>
              <p className="m-0 punjab-static-h">
                <b>TOTAL FEMALE PRISONERS</b>
              </p>
              <div className="d-flex align-items-end">
                <div>
                  <p
                    className="m-0"
                    style={{
                      fontSize: "38px",
                      color: "#000",
                      fontFamily: "Abril Fatface",
                    }}
                  >
                    <CountUp end={1399} redraw={true} separator=",">
                      {({ countUpRef, start }) => (
                        <VisibilitySensor onChange={start} delayedCall>
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                  </p>
                </div>
                <div className="ms-2">
                  <p
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginBottom: "10px",
                    }}
                  >
                    *by end of Year 2021
                  </p>
                </div>
              </div>
            </div>
            <div>
              <p className="m-0 punjab-static-h">
                <b>PERCENTAGE IN PAKISTAN</b>
              </p>
              <div className="d-flex align-items-end">
                <div>
                  <p
                    className="m-0"
                    style={{
                      fontSize: "38px",
                      color: "#000",
                      fontFamily: "Abril Fatface",
                    }}
                  >
                    <CountUp end={1.6} redraw={true} decimals={1}>
                      {({ countUpRef, start }) => (
                        <VisibilitySensor onChange={start} delayedCall>
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                    *
                  </p>
                </div>

                <div className="ms-2">
                  <p
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginBottom: "10px",
                    }}
                  >
                    by end of Year 2021
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col">
          <div>
            <p
              className="m-0 punjab-static-h"
              style={{
                fontSize: "18px",
              }}
            >
              <b>SIGNIFICANT FACTS</b>
            </p>
            <div>
              <p
                className="m-0 punjab-static-h"
                style={{
                  color: "#000",
                }}
              >
                <b>Seprate Jails in Punjab</b>
              </p>
              <div className="d-flex align-items-end">
                <div>
                  <p
                    className="m-0"
                    style={{
                      fontSize: "28px",
                      color: "#C1573B",
                      fontFamily: "Abril Fatface",
                    }}
                  >
                    <CountUp end={1} redraw={true} separator=",">
                      {({ countUpRef, start }) => (
                        <VisibilitySensor onChange={start} delayedCall>
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>{" "}
                    Specialized jail in Multan
                  </p>
                </div>
              </div>
            </div>
            <div>
              <p
                className="m-0 punjab-static-h"
                style={{
                  color: "#000",
                }}
              >
                <b>earning opportunity in Balochistan</b>
              </p>
              <div className="d-flex align-items-end">
                <div>
                  <p
                    className="m-0"
                    style={{
                      fontSize: "38px",
                      color: "#C1573B",
                      fontFamily: "Abril Fatface",
                    }}
                  >
                    NO
                  </p>
                </div>
              </div>
            </div>
            <div>
              <p
                className="m-0 punjab-static-h"
                style={{
                  color: "#000",
                }}
              >
                <b>prisoners remain under trial </b>
              </p>
              <div className="d-flex align-items-end">
                <div>
                  <p
                    className="m-0"
                    style={{
                      fontSize: "38px",
                      color: "#C1573B",
                      fontFamily: "Abril Fatface",
                    }}
                  >
                    <CountUp end={76} redraw={true} separator=",">
                      {({ countUpRef, start }) => (
                        <VisibilitySensor onChange={start} delayedCall>
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                    %
                  </p>
                </div>
              </div>
            </div>

            <div>
              <p
                className="m-0 punjab-static-h"
                style={{
                  color: "#000",
                }}
              >
                <b>Separate prisons in KP and Balochistan</b>
              </p>
              <div className="d-flex align-items-end">
                <div>
                  <p
                    className="m-0"
                    style={{
                      fontSize: "38px",
                      color: "#C1573B",
                      fontFamily: "Abril Fatface",
                    }}
                  >
                    NO
                  </p>
                </div>
              </div>
            </div>
            <div>
              <p
                className="m-0 punjab-static-h"
                style={{
                  color: "#000",
                }}
              >
                <b>Compared to men, more difficulty accessing healthcare</b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WomenPrisonStatistics;
